import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { QuickQuoteForm } from "@/components/forms/QuickQuoteForm";
import { RestoreLocationsMap } from "@/components/site/RestoreLocationsMap";

const CONTACT_HERO =
  "/img/r/wp-2022-05-group-289-1.webp";

const TITLE = "Contact RESTORE Hair - A Leader in Hair Restoration";
const DESCRIPTION =
  "RESTORE Hair Locations | Chicago, Charlotte, Dallas, Denver & New York City. Contact RESTORE Hair today about balding, hair restoration, and No-Shave F.U.E.";
const URL = "https://restorehair.com/contact-us/";

export const Route = createFileRoute("/contact-us/")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: ContactUsPage,
});

function ContactUsPage() {
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <section className="bg-background">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div
              className="min-h-[320px] lg:min-h-[720px]"
              style={{
                backgroundImage: `url(${CONTACT_HERO})`,
                backgroundSize: "cover",
                backgroundPosition: "50% 50%",
                backgroundRepeat: "no-repeat",
              }}
              role="img"
              aria-label="RESTORE Hair clinic reception"
            />
            <div className="px-4 py-10 md:px-10 md:py-14">
              <div className="mx-auto max-w-xl text-center">
                <h1 className="text-sm font-semibold uppercase tracking-wide text-foreground">
                  CONTACT RESTORE® Hair
                </h1>
                <h2 className="mt-3 text-3xl font-extrabold leading-tight text-foreground md:text-5xl">
                  Get a quick quote.{" "}
                  <span className="font-light italic">It&rsquo;s easy.</span>
                </h2>
                <p className="mt-4 text-base leading-relaxed text-muted-foreground md:text-lg">
                  Give us a minute, we&rsquo;ll give you the world.
                </p>
              </div>
              <div className="mx-auto mt-6 max-w-xl">
                <QuickQuoteForm />
              </div>
            </div>
          </div>
        </section>

        <RestoreLocationsMap />

        <section className="py-8">
          <div className="mx-auto max-w-4xl px-4 text-center text-sm leading-relaxed text-muted-foreground lg:px-8">
            Restoration Holdings LLC is a healthcare management company focused exclusively on{" "}
            <a href="/no-shave-fue-hair-transplant/" className="underline underline-offset-2 hover:no-underline">
              hair restoration solutions,
            </a>{" "}
            serving affiliated doctors in{" "}
            <a href="/locations/restore-denver/" className="underline underline-offset-2 hover:no-underline">
              Denver CO
            </a>
            ,{" "}
            <a href="/locations/restore-chicago/" className="underline underline-offset-2 hover:no-underline">
              Chicago IL
            </a>
            ,{" "}
            <a href="/locations/restore-dallas/" className="underline underline-offset-2 hover:no-underline">
              Dallas TX
            </a>
            ,{" "}
            <a href="/locations/restore-charlotte/" className="underline underline-offset-2 hover:no-underline">
              Charlotte, NC
            </a>
            , and{" "}
            <a href="/locations/new-york/" className="underline underline-offset-2 hover:no-underline">
              New York City
            </a>
            .
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}